<template>
  <ul
    class="grid grid-cols-3 mt-3 md:mt-5 gap-5 pb-10 md:flex md:gap-14 flex-wrap"
  >
    <li v-for="(item, index) in items" :key="item" class="flex gap-5">
      <div
        :style="{ background: colors[index % colors.length] }"
        class="size-[13px] shrink-0 mt-[3px] rounded-2xl"
      />
      <div class="font-medium uppercase text-xs text-balance">{{ item }}</div>
    </li>
  </ul>
</template>

<script setup lang="ts">
defineProps<{
  items: string[]
  colors: string[]
}>()
</script>
